import React, { useEffect } from 'react';
import { FormattedMessage, IntlProvider } from 'react-intl';
import { getUserInfo } from '@games/api';
import MyLink from 'features/home/components/MyLink';
import { localeData } from '../../../intl';
import intlMessages from '../../../intl/messages';
import NavMain from './NavMain';
import HelmetHeaders from './HelmetHeaders';
import { DailyHero } from '../../puzzle/components/DailyHero';

const solveForLang = () => {
  const me = getUserInfo();
  const re_lang_url = /\/([a-z][a-z])\//;
  let match;
  let [lang] = (
    (navigator.languages && navigator.languages[0]) ||
    navigator.language
  )
    .toLowerCase()
    .split(/[_-]+/);

  if (me && me.lang) {
    ({ lang } = me);
  }

  if (window && window.location && window.location.pathname) {
    match = re_lang_url.exec(window.location.pathname);
    if (match) {
      [, lang] = match;
    } else {
    }
  }
  if (!(lang in localeData)) {
    lang = 'en';
  }
  return {
    lang,
    messages: localeData[lang as keyof typeof localeData],
  };
};

const App: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const currentYear = (new Date()).getFullYear();
  const { lang, messages } = solveForLang();

  useEffect(() => {
    const keepMinHEl = document.getElementById('keep-min-h');
    if (keepMinHEl) {
      const observer = new MutationObserver(() => {
          keepMinHEl.style.minHeight = '100vh';
      });
      observer.observe(keepMinHEl, {
        attributes: true,
        attributeFilter: ['style'],
      });
      return () => {
        observer.disconnect();
      };
    }
  }, []);

  return (
    <IntlProvider locale={lang} messages={messages}>
      <HelmetHeaders />
      <div
        id='keep-min-h'
        className='dark:bg-slate-900 dark:text-slate-100 min-h-screen'
      >
        <NavMain />
        <DailyHero />
        <div className='container mt-4 px-4 mx-auto'>
          {children}
        </div>
        <div className='container text-center py-4 mx-auto'>
          Copyright &copy; 2007-{currentYear}
          {' - '}
          <MyLink href='/contact/'>Barry Gilbert</MyLink>
          {' - '}
          <MyLink href='/privacy/'>
            <FormattedMessage {...intlMessages.privacyPolicy} />
          </MyLink>
          {' - '}
          <MyLink href='/tos/'>
            <FormattedMessage {...intlMessages.termsOfService} />
          </MyLink>
        </div>
      </div>
    </IntlProvider>
  );
};

export default App;
